import { render, staticRenderFns } from "./dashboardFilters.vue?vue&type=template&id=b158d62c&scoped=true&"
import script from "./dashboardFilters.vue?vue&type=script&lang=js&"
export * from "./dashboardFilters.vue?vue&type=script&lang=js&"
import style0 from "./dashboardFilters.vue?vue&type=style&index=0&id=b158d62c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b158d62c",
  null
  
)

export default component.exports